import { tagFilter } from "../tagFilter";

import type { StaticFilterField } from "./StaticFilterField";

/** The devices table's filter rows, in picker order. */
export const DEVICE_FILTER_FIELDS = [
  { type: "string", field: "device_id", name: "Device ID" },
  // The Devices catalog accepts only membership comparators on `tags`;
  // an unrestricted string row would offer equality/substring filters
  // the backend rejects on submit.
  { type: "string", field: "tags", name: "Tags", ...tagFilter },
  { type: "identity", field: "created_by", name: "Created By" },
  { type: "date", field: "created", name: "Created" },
  { type: "date", field: "modified", name: "Modified" },
  { type: "identity", field: "modified_by", name: "Modified By" },
] as const satisfies readonly StaticFilterField[];
